import React, { useEffect, useState } from "react";
import { getSingleProfieFile } from "../../context/apiCalls/apiCalls";
import ProfilePopup from "../Profile/ProfilePopup";
import SharePopup from "../SharePopup/SharePopup";

export default function Notifications({ notification, status, token }) {
  const [timeAgo, setTimeAgo] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [singleFileDetails, setSingleFileDetails] = useState({});
  const [share, setShare] = useState(false);
  const [singleFileLoading, setSingleFileLoading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Date.now() - Date.parse(notification?.createdTime);
      setTimeAgo(categorizeTime(elapsed));
    }, 60000); // update every minute

    return () => clearInterval(interval);
  }, [notification?.createdTime]);

  function categorizeTime(elapsed) {
    if (elapsed < 60000) {
      return "Just now";
    } else if (elapsed < 180000) {
      const seconds = Math.floor(elapsed / 1000);
      return `${seconds} seconds ago`;
    } else if (elapsed < 3600000) {
      const minutes = Math.floor(elapsed / 60000);
      return `${minutes} min ago`;
    } else {
      const days = Math.floor(elapsed / 86400000);
      return `${days} days ago`;
    }
  }
  const handleFileClick = async () => {
    const { campaignId, contestId, entryId, orgId } =
      notification?.entryPointer;
    setSingleFileDetails([]);
    setShowPreview(true);
    setSingleFileLoading(true);
    const data = await getSingleProfieFile(
      campaignId,
      contestId,
      entryId,
      token,
      orgId
    );
    setSingleFileDetails(data);
    setSingleFileLoading(false);
  };
  const handleShare = () => {
    if (notification?.type === "SHARE_URL") {
      setShare(share ? false : true);
    }
  };
  return (
    <>
      <div className="flex gap-[7px] items-start py-[20px] w-[100%] relative z-10">
        <div className="min-w-[42px] h-[42px] bg-[#1F1F1F] rounded-full flex items-center justify-center relative">
          <img src={notification?.display?.leftThumbnailUrl} />
          {status == "NEW" && (
            <div className="new-notification-indication absolute top-[2px] right-[2px]" />
          )}
        </div>
        <div className="w-[calc(100%-49px)]">
          <p className="break-words text-small text-[#CDCDCD]  mb-[10px] w-[100%]">
            {notification?.display?.text}
          </p>
          {/* <p className="text-small text-[#CDCDCD] ">{timeAgo}</p> */}
          {notification?.display?.thumbnailUrl &&
            notification?.type !== "SHARE_URL" && (
              <div
                className="flex gap-[10px] items-center cursor-pointer"
                onClick={handleFileClick}
              >
                <img
                  src={notification?.display?.thumbnailUrl}
                  className="w-[42px] h-[42px] object-cover"
                />
                <p className="text-small text-[#DAFF48]">View entry</p>
              </div>
            )}
          {notification?.display?.thumbnailUrl &&
            notification?.type == "SHARE_URL" && (
              <div
                className="flex gap-[10px] items-center cursor-pointer"
                onClick={handleShare}
              >
                <img
                  src={notification?.display?.thumbnailUrl}
                  className="w-[42px] h-[42px] object-cover"
                />
                <p className="text-small text-[#DAFF48]">Share Your Entry</p>
              </div>
            )}
        </div>
      </div>
      {share && (
        <SharePopup
          showShare={handleShare}
          type="notification"
          url={notification?.entryPointer?.shareUrl}
        />
      )}
      {showPreview && (
        <ProfilePopup
          setShowPreview={setShowPreview}
          singleFileDetails={singleFileDetails}
          singleFileLoading={singleFileLoading}
          token={token}
          type="notification"
          //   profileContent={profileContent}
          setSingleFileDetails={setSingleFileDetails}
        />
      )}
    </>
  );
}
